import { Injectable, Inject } from '@angular/core';
import { BaseApi } from '../abstracts';
import {
  API_CONFIGURATION_TOKEN,
  ApiConfiguration
} from '../tokens/api.configuration';
import { HttpClient } from '@angular/common/http';
import { JwtService } from '@ecosure-suite/shared/util-auth';


@Injectable({
  providedIn: 'root'
})
export class ClaimsApiService extends BaseApi {
  constructor(
    @Inject(API_CONFIGURATION_TOKEN) configuration: ApiConfiguration,
    http: HttpClient, jwtService: JwtService
  ) {
    super(http, jwtService);
    this.server = configuration.claims_uri;
    
  }
}
